//import MojitoServices from 'mojito/services';
import translations from 'config/translations.l10n.yaml'; // This will be transpiled by webpack.translations-loader
import defaultConfig from 'config/default-config.yaml'; // URL to sportium-es-config.yaml, resolved using alias in webpack

import {configureSportsbook} from '#core/sportsbook-initializer.js';

import fonts from './config/fonts.yaml';
import {BASIC_PALETTE} from './config/theme';
import AliraSSOService from './alira/sso-service.js';
import {getTokens} from './config/viewsconfig';
import INTENT from './config/intent';
import footer from './views/applicationfooter/index.jsx';
import PageContextMenu from './views/page-context-menu/page-context-menu.jsx';

import '#core/features/analytics/connextra/index.js';
import '#core/portal/portal-listener.js';

const isSportiumEs = CLIENT_NAME === 'sportium-es';

function getMojitoConfig(config) {
    INTENT.init();
    return {
        customRoutes: [],
        services: {
            authenticationService: {
                // only if specified in config
                ssoImplementation: config.loginIntegrationBaseURL
                    ? new AliraSSOService(config.loginIntegrationBaseURL)
                    : undefined,
            },
            viewImplementations: {
                ApplicationFooter: {
                    implementation: !isSportiumEs ? footer : undefined,
                },
                PageContextMenu: {
                    implementation: PageContextMenu,
                },
            },
        },
    };
}

configureSportsbook({
    getMojitoConfigFn: getMojitoConfig,
    getTokensFn: getTokens,
    configuration: {
        ...defaultConfig,
        translations,
        palette: {
            BASIC: BASIC_PALETTE,
        },
        fonts,
    },
});
